"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const GetApp_1 = __importDefault(require("@mui/icons-material/GetApp"));
const InsertDriveFile_1 = __importDefault(require("@mui/icons-material/InsertDriveFile"));
const DoDisturb_1 = __importDefault(require("@mui/icons-material/DoDisturb"));
const services_1 = require("../services");
const shared_1 = require("../shared");
const react_router_dom_1 = require("react-router-dom");
const PreviewModelPopup_1 = __importDefault(require("../PreviewModelPopup"));
const steps = [
    {
        label: 'Step 1',
        content: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Navigate to the College Board website and find the practice score report you wish to upload for analysis", ' ', (0, jsx_runtime_1.jsx)(Link_1.default, Object.assign({ href: 'https://mypractice.collegeboard.org/', target: '_blank', rel: 'noopener noreferrer' }, { children: "https://mypractice.collegeboard.org/" }))] })),
    },
    {
        label: 'Step 2',
        content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Click on Score Details, then scroll down to the question list and select view all to make sure all questions are displayed." }),
    },
    {
        label: 'Step 3',
        content: 'Scroll all the way to the top of the webpage, then right-click on the Score Details heading (blue area) and select Print',
    },
    {
        label: 'Step 4',
        content: 'Save the page as a PDF by opening the Print menu and selecting "Save as PDF"',
    },
    {
        label: 'Step 5',
        content: 'Drag and drop or upload the file from Step 4 into the box on the right',
    },
    // { label: 'Step 6', content: 'Upload your test' },
    {
        label: 'Step 6',
        content: 'Verify your score report is in our system, then enter you score and click "proceed" to accelerate your skill building and subject mastery!',
    },
];
function useUserId() {
    const { userId } = (0, react_router_dom_1.useParams)();
    return userId;
}
const UploadSat = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const userId = useUserId();
    const [file, setFile] = react_1.default.useState(null);
    const [isDragging, setIsDragging] = react_1.default.useState(false);
    const [showReviewButton, setShowReviewButton] = react_1.default.useState(false);
    const [parse, { isLoading, isSuccess, isError, data }] = (0, services_1.useParseMutation)();
    const [isScanning, setIsScanning] = react_1.default.useState(false);
    const [bluebookCategories, setBluebookCategories] = react_1.default.useState([]);
    const [combinedData, setCombinedData] = react_1.default.useState([]);
    const [bluebookData, setBluebookData] = react_1.default.useState(null);
    const [scoreConversionDataArray, setScoreConversionDataArray] = react_1.default.useState([]);
    const [addDiagnostic, { isLoading: isCreating }] = (0, services_1.useCreateDiagnosticMutation)();
    const [isPreviewOpen, setIsPreviewOpen] = react_1.default.useState(false);
    const [previewData, setPreviewData] = react_1.default.useState(null);
    const [snackbarOpen, setSnackbarOpen] = react_1.default.useState(false);
    const [snackbarMessage, setSnackbarMessage] = react_1.default.useState('');
    const [snackbarSeverity, setSnackbarSeverity] = react_1.default.useState('error');
    const [scoreRange, setScoreRange] = react_1.default.useState({
        readingAndWritting: '',
        math: '',
    });
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            try {
                const data = await (0, shared_1.getStrapiData)(`bluebook-categorizations?&populate=*&pagination[pageSize]=10000`);
                if (data.length > 0) {
                    setBluebookCategories(data);
                }
            }
            catch (error) {
                console.error('Error fetching bluebook categories:', error);
            }
        };
        fetchData();
    }, []);
    (0, react_1.useEffect)(() => {
        const scoreConversion = async () => {
            try {
                const scoredata = await (0, shared_1.getStrapiData)(`score-conversions?&populate=*&pagination[pageSize]=10000`);
                if (scoredata) {
                    // Filter data based on the nested `Name` attribute
                    const filtered = scoredata.filter((item) => {
                        var _a, _b, _c, _d;
                        const diagnosticName = (_d = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.attributes) === null || _a === void 0 ? void 0 : _a.Diagnostic) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.Name;
                        return diagnosticName == 'Test 1 - Math - Module 2A' || diagnosticName == 'Test 1 - Reading and Writing - Module 2A';
                    });
                    setScoreConversionDataArray(filtered); // Save filtered data to state
                }
                else {
                    console.warn('No valid data found in API response.');
                }
            }
            catch (error) {
                console.error('Error fetching score conversions:', error);
            }
        };
        scoreConversion();
    }, []);
    // const processModulePerformance = (
    //     modulePerformance: ModulePerformance,
    //     scoreConversionDataArray: ScoreConversionData[]
    // ): Record<string, string> => {
    //     const scoreRange: Record<string, string> = {}; // Object to store score ranges
    //     for (const [subject, data] of Object.entries(modulePerformance)) {
    //         const { correctAnswers, totalAnswers } = data;
    //      // Normalize subject to handle "Writting" vs. "Writing"
    //         const normalizedSubject = subject.toLowerCase().replace(/writting/g, "writing");
    //         // Match the TotalDiagnosticScore and subject name
    //         const matchingScoreData = scoreConversionDataArray.find(score => {
    //             const TotalDiagnosticScore = score.attributes?.TotalDiagnosticScore; // Access TotalDiagnosticScore
    //             const Name = score.attributes?.Diagnostic?.data?.attributes?.Name; // Access Name
    //             const { LowScoreRange, HighScoreRange } = score.attributes; // Access ranges directly
    //             if (typeof TotalDiagnosticScore !== "number") {
    //                 console.warn("Invalid or missing TotalDiagnosticScore.");
    //                 return false;
    //             }
    //             // Normalize Name to handle "Writting" vs. "Writing"
    //             const normalizedName = Name?.toLowerCase().replace(/writting/g, "writing");
    //             // General match for TotalDiagnosticScore
    //             const matchesTotal = TotalDiagnosticScore === correctAnswers;
    //             // Match normalized subject with normalized name
    //             const matchesName = normalizedName?.includes(normalizedSubject);
    //             return matchesTotal && matchesName; // Match both TotalDiagnosticScore and normalized Name
    //         });
    //         if (matchingScoreData) {
    //             const { LowScoreRange, HighScoreRange } = matchingScoreData.attributes;
    //             const Name = matchingScoreData.attributes?.Diagnostic?.data?.attributes?.Name || "Unknown";
    //             // Create score range string for the current subject
    //             scoreRange[subject] = `${LowScoreRange}-${HighScoreRange}`;
    //         } else {
    //             console.warn(
    //                 `No matching data found for subject: ${subject} with correctAnswers: ${correctAnswers}`
    //             );
    //             scoreRange[subject] = "N/A";
    //         }
    //     }
    //     return scoreRange;
    // };
    const CreatepostCall = async (localScores) => {
        try {
            if (!userId) {
                console.warn('User ID is not available.');
                return;
            }
            if (combinedData.length > 0) {
                const combinedDataObject = combinedData;
                const bluebookDataSerialized = JSON.stringify(combinedDataObject);
                const extraTimeOptions = ''; // Modify as needed
                // Use the localScores directly
                const formattedScoreRange = {
                    'Reading and Writing': localScores.readingAndWritting,
                    Math: localScores.math,
                };
                // Set `type` as 1 and `testtype` as 94 directly
                const type = 1;
                const testtype = 94;
                const summarySerialized = JSON.stringify((bluebookData === null || bluebookData === void 0 ? void 0 : bluebookData.summary) || {});
                const testinfoSerialized = JSON.stringify((bluebookData === null || bluebookData === void 0 ? void 0 : bluebookData.testInfo) || {});
                const modulePerformanceSerialized = JSON.stringify((bluebookData === null || bluebookData === void 0 ? void 0 : bluebookData.modulePerformance) || {});
                const knowledgeAndSkillsSerialized = JSON.stringify((bluebookData === null || bluebookData === void 0 ? void 0 : bluebookData.knowledgeAndSkills) || []);
                // Create the payload with additional properties
                const response = await addDiagnostic({
                    userId: userId,
                    diagnostics: [],
                    type,
                    testtype,
                    isBlueBookData: true,
                    bluebookData: bluebookDataSerialized,
                    extraTimeOptions,
                    scoreRange: formattedScoreRange,
                    summary: summarySerialized,
                    testinfo: testinfoSerialized,
                    modulePerformance: modulePerformanceSerialized,
                    knowledgeAndSkills: knowledgeAndSkillsSerialized,
                });
                navigate(`/reports/${userId}`);
            }
            else {
                console.warn('No combined data available for postCall.');
            }
        }
        catch (error) {
            console.error('Error in postCall function:', error);
        }
    };
    function normalizeSection(section) {
        switch (section) {
            case 'Reading and Writing':
                return 'RW1';
            case 'Reading and Writing 2 Easy':
                return 'RW2E';
            case 'Reading and Writing 2 Hard':
                return 'RW2H';
            case 'Math':
                return 'M1';
            case 'Math 2 Easy':
                return 'M2E';
            case 'Math 2 Hard':
                return 'M2H';
            default:
                return section; // Return as is for any other case
        }
    }
    const handleReviewClick = () => {
        setIsScanning(true);
        setTimeout(() => {
            handleUpload();
        }, 2000);
    };
    const handleFileUpload = async (uploadedFile) => {
        var _a, _b, _c;
        if (uploadedFile.type !== 'application/pdf') {
            setSnackbarMessage('Invalid file type. Please upload a PDF file.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true); // Open Snackbar
            return;
        }
        setFile(uploadedFile);
        setIsScanning(true);
        try {
            const response = await parse(uploadedFile).unwrap();
            if (response.data) {
                let finalData;
                // Determine if parsing is needed
                if (typeof response.data === 'string') {
                    finalData = JSON.parse(response.data);
                }
                else if (typeof response.data === 'object') {
                    finalData = response.data;
                }
                else {
                    console.error('Unexpected data type:', typeof response.data);
                    return;
                }
                console.log('finalData ', finalData);
                if (finalData === null || finalData === void 0 ? void 0 : finalData.summary) {
                    if (((_a = finalData === null || finalData === void 0 ? void 0 : finalData.summary) === null || _a === void 0 ? void 0 : _a.totalQuestions) === ((_b = finalData === null || finalData === void 0 ? void 0 : finalData.summary) === null || _b === void 0 ? void 0 : _b.correctAnswers) + ((_c = finalData === null || finalData === void 0 ? void 0 : finalData.summary) === null || _c === void 0 ? void 0 : _c.incorrectAnswers)) {
                        setBluebookData(finalData);
                        // Open preview with parsed data
                        const combinedResult = combineData(finalData);
                        setCombinedData(combinedResult);
                        setPreviewData(finalData);
                        setIsPreviewOpen(true);
                        setIsScanning(false);
                    }
                    else {
                        //alert('Uploaded file does not match the requirement.');
                        setSnackbarMessage('The uploaded PDF does not match the required format. Please ensure it meets all formatting guidelines before submitting.\n Refer the video for guidelines.');
                        setSnackbarSeverity('error');
                        setSnackbarOpen(true); // Open Snackbar
                        setIsScanning(false);
                        removeFile();
                    }
                }
            }
        }
        catch (error) {
            console.error('Error while uploading file:', error);
            setIsScanning(false);
            alert('Error processing the file. Please try again.');
        }
    };
    const handleUpload = async () => {
        if (!file) {
            alert('Please select a file first.');
            return;
        }
        try {
            const response = await parse(file).unwrap();
            if (response.data) {
                let finalData;
                // Determine if parsing is needed
                if (typeof response.data === 'string') {
                    finalData = JSON.parse(response.data);
                }
                else if (typeof response.data === 'object') {
                    finalData = response.data;
                }
                else {
                    console.error('Unexpected data type:', typeof response.data);
                    return;
                }
                // Set the bluebookData state
                setBluebookData(finalData);
                // Pass finalData directly to combineData
                const combinedResult = combineData(finalData);
                // Update the combined data state
                setCombinedData(combinedResult);
                setIsScanning(false);
            }
        }
        catch (error) {
            console.error('Error while uploading file:', error);
            // Handle error appropriately
        }
    };
    function combineData(data) {
        const newCombinedData = [];
        // Check if data exists and has questions
        if (!data || !data.questions) {
            console.error('No questions data available in bluebookData');
            return newCombinedData;
        }
        // Ensure data.questions is an array
        const questions = Array.isArray(data.questions) ? data.questions : [];
        questions.forEach((question) => {
            const { practiceTest, question: questionNumber, section } = question, rest = __rest(question, ["practiceTest", "question", "section"]);
            const normalizedSection = normalizeSection(section);
            // Find matching category based on practiceTest, questionNumber, and normalizedSection
            const matchingCategory = bluebookCategories.find((category) => {
                const attributes = category.attributes;
                return attributes.PracticeTest == practiceTest && attributes.QuestionNumber == questionNumber && attributes.Module === normalizedSection;
            });
            if (matchingCategory) {
                // Create a new object combining the data
                const combinedItem = Object.assign(Object.assign({}, matchingCategory), { questionData: Object.assign(Object.assign({}, rest), { // Spread the original question data
                        practiceTest,
                        questionNumber,
                        section }) });
                newCombinedData.push(combinedItem);
            }
            else {
                console.log(`No matching category found for question number: ${questionNumber}, section: ${section}`);
            }
        });
        setCombinedData(newCombinedData);
        return newCombinedData;
    }
    const handleSnackbarClose = () => {
        setSnackbarOpen(false); // Close Snackbar
    };
    const dragOver = (e) => {
        e.preventDefault();
    };
    const dragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };
    const dragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };
    const handleFileDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFile = e.dataTransfer.files[0];
        handleFileUpload(droppedFile);
    };
    const handleFileChange = (e) => {
        var _a;
        const selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (selectedFile) {
            handleFileUpload(selectedFile);
        }
    };
    const handleThisPcClick = () => {
        var _a;
        (_a = document.getElementById('fileInput')) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handlePreviewClose = () => {
        setIsPreviewOpen(false);
        setPreviewData(null);
        removeFile();
    };
    const handleProceed = react_1.default.useCallback((localScores) => {
        if (combinedData.length === 0) {
            console.warn('Combined data is empty.');
            setSnackbarMessage('The mapping configuration is not found for this practice test.');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }
        CreatepostCall(localScores);
    }, [combinedData]);
    const removeFile = (e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setFile(null);
        setIsScanning(false);
        setShowReviewButton(false);
        // Reset the file input value
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.value = '';
        }
    };
    const PreviewModal = () => {
        if (!isPreviewOpen || !previewData)
            return null;
        return (0, jsx_runtime_1.jsx)(PreviewModelPopup_1.default, { isPreviewOpen: isPreviewOpen, handlePreviewClose: handlePreviewClose, data: previewData, handleProceed: handleProceed });
    };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ width: '100%', p: 2 }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h4', align: 'center', color: '#0146C7 !important', sx: { fontFamily: 'Poppins, sans-serif', fontWeight: 600 }, gutterBottom: true }, { children: "Add Your Bluebook Diagnostic" })), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ display: 'flex', width: '100%', mt: 1, height: '100%' }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ flex: 1, p: 2, pt: 0, pb: 0, borderRight: '1px solid #ccc' }, { children: [steps.map((step, index) => ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    mb: 1,
                                } }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                                                    backgroundColor: '#1976d2',
                                                    color: 'white',
                                                    padding: '4px 8px',
                                                    borderRadius: 4,
                                                    marginRight: 1,
                                                    minWidth: '60px',
                                                } }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body2' }, { children: step.label })) })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', sx: { ml: 1 } }, { children: step.content }))] })), index < steps.length - 1 && ((0, jsx_runtime_1.jsx)(Divider_1.default, { orientation: 'vertical', flexItem: true, sx: {
                                            backgroundColor: '#ccc',
                                            width: '2px',
                                            alignSelf: 'start',
                                            height: 15,
                                            mt: 1,
                                            ml: 3,
                                        } }))] }), index))), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ mt: 4, width: '100%' }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', color: '#0146C7', fontWeight: 'bold', gutterBottom: true }, { children: "Watch this tutorial to get started" })), (0, jsx_runtime_1.jsx)("iframe", { width: '75%', height: '275px', style: { borderRadius: '8px', border: 'none' }, src: 'https://www.youtube.com/embed/uBqn0wk-Ao8', title: 'Desmos offering', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', sandbox: 'allow-same-origin allow-forms allow-popups allow-scripts allow-presentation', allowFullScreen: true })] }))] })), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '50%', p: 2 }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ width: '100%', height: '70vh', border: `2px dashed ${isDragging ? '#0146C7' : '#ccc'}`, borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', onDragOver: dragOver, onDragEnter: dragEnter, onDragLeave: dragLeave, onDrop: handleFileDrop, onClick: handleThisPcClick, style: { cursor: 'pointer', position: 'relative' } }, { children: !file ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(GetApp_1.default, { style: {
                                                fontSize: '48px',
                                                color: isDragging ? '#0146C7' : '#888',
                                            } }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', style: {
                                                color: isDragging ? '#0146C7' : '#888',
                                                marginTop: '8px',
                                            } }, { children: "Click to upload or drag and drop" })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body2', style: { color: '#aaa' } }, { children: "Maximum file size 50 MB." })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body2', style: { color: '#aaa', backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px' } }, { children: "Kindly note that the PDF will be processed using AI, and the process may take over 2 minutes to complete. We appreciate your patience." }))] })) : ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                                        width: '75%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2,
                                    } }, { children: isScanning ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/uploadscanner.gif', alt: 'Scanning', style: { width: '15%' } }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', color: 'primary', sx: { fontSize: '1.25rem', textAlign: 'center' } }, { children: "AI is analyzing your PDF. Kindly stay on this page until the process is completed." })), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.75 } }, { children: [(0, jsx_runtime_1.jsx)(DoDisturb_1.default, { sx: { fontSize: 25, color: 'red', textAlign: 'center' } }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body2', color: 'primary', sx: { textAlign: 'center', fontSize: '1.25rem' } }, { children: "This may take 1-2 minutes" }))] }))] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isScanning && file && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(InsertDriveFile_1.default, { sx: { fontSize: 48, color: '#0146C7' } }), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', color: 'primary' }, { children: file.name })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ size: 'small', onClick: (e) => {
                                                                e.stopPropagation();
                                                                removeFile();
                                                            } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, { sx: { fontSize: 20 } }) }))] }))] })) })) }))) })), (0, jsx_runtime_1.jsx)("input", { type: 'file', id: 'fileInput', multiple: true, accept: 'application/pdf', onChange: handleFileChange, style: { display: 'none' } }), (0, jsx_runtime_1.jsx)(PreviewModal, {})] }))] })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ open: snackbarOpen, autoHideDuration: 6000, onClose: handleSnackbarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }, { children: (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ onClose: handleSnackbarClose, severity: snackbarSeverity, variant: 'filled', sx: { width: '100%', whiteSpace: 'pre-line' } }, { children: snackbarMessage })) }))] })));
};
exports.default = UploadSat;
